import { Image, Line, Shape, Text } from "react-pptx";
import {
  IndustryBenchMarkRowType,
  industryStylings,
} from "../../../Reuseables/DashboardComponents/OverallIndustryResultsTable";
import { relativeChange } from "../../../../helpers/utils";

type BenchmarkPP = {
  x: any;
  y: any;
  bm: IndustryBenchMarkRowType;
  translation: any;
};

export const BenchmarkPP: React.FC<BenchmarkPP> = ({
  x,
  y,
  bm,
  translation,
}) => {
  return (
    <>
      <Shape
        type="rect"
        style={{ x: x, y: y, w: 2.5, h: 1.5, borderColor: "#5BBFAC" }}
      />
      <Shape
        type="rect"
        style={{
          x: x,
          y: y,
          w: 2.5,
          h: 0.75,
          backgroundColor: "#5BBFAC",
          borderColor: "#5BBFAC",
        }}
      />
      <Text
        style={{
          x: x + 0.8,
          y: y + 0.2,
          fontSize: 9,
          color: "#000000",
          h: 0.2,
        }}
      >
        MLI® {bm.device}
      </Text>
      <Text
        style={{
          x: x + 0.8,
          y: y + 0.4,
          fontSize: 9,
          color: "#000000",
          h: 0.2,
          w: 2,
        }}
      >
        {translation(bm.industry)}
      </Text>
      <Image
        style={{ x: x + 0.3, y: y + 0.15, h: 0.5, w: 0.5 }}
        src={{ kind: "path", path: industryStylings[bm.industry].iconUrl }}
      />
      <Text
        style={{
          fontSize: 10,
          bold: true,
          x: x + 0.4,
          y: y + 0.8,
          h: 0.2,
          w: 0.5,
        }}
      >
        MLI
      </Text>
      <Text
        style={{
          fontSize: 10,
          bold: true,
          x: x + 1.6,
          y: y + 0.8,
          h: 0.2,
          w: 0.5,
        }}
      >
        Pain
      </Text>
      <Line
        style={{ width: 0.1, color: "#808080" }}
        x1={x + 1.25}
        x2={x + 1.25}
        y1={y + 0.9}
        y2={y + 1.4}
      />
      <Text
        style={{
          align: "center",
          fontSize: 10,
          bold: true,
          x: x + 0.1,
          y: y + 1,
          w: 1,
          h: 0.2,
        }}
      >
        {bm.mli.toFixed(1)}
        {bm.mliBenchmark && ` / BM ${bm.mliBenchmark.toFixed(1)}`}
      </Text>
      <>
        {relativeChange(bm.mli, bm.mliBenchmark) * 100 > 0 ? (
          <Text
            style={{
              fontSize: 6,
              color: "#FF0000",
              bold: true,
              x: x + 0.1,
              y: y + 1.25,
              w: 1.2,
              h: 0.2,
            }}
          >
            {`${relativeChange(bm.mli, bm.mliBenchmark).toFixed(
              1
            )}% over benchmark`}
          </Text>
        ) : (
          <Text
            style={{
              fontSize: 6,
              color: "#008000",
              bold: true,
              x: x + 0.1,
              y: y + 1.25,
              w: 1.2,
              h: 0.2,
            }}
          >
            {`${-relativeChange(bm.mli, bm.mliBenchmark).toFixed(
              1
            )}% below benchmark`}
          </Text>
        )}
      </>
      <Text
        style={{
          align: "center",
          fontSize: 10,
          bold: true,
          x: x + 1.35,
          y: y + 1,
          w: 1,
          h: 0.2,
        }}
      >
        {bm.pain.toFixed(1)}
        {bm.painBenchmark && ` / BM ${bm.painBenchmark.toFixed(1)}`}
      </Text>
       <>
        {relativeChange(bm.pain, bm.painBenchmark) * 100 > 0 ? (
          <Text
            style={{
              fontSize: 6,
              color: "#FF0000",
              bold: true,
              x: x + 1.35,
              y: y + 1.25,
              w: 1.2,
              h: 0.2,
            }}
          >
            {`${relativeChange(bm.pain, bm.painBenchmark).toFixed(
              1
            )}% over benchmark`}
          </Text>
        ) : (
          <Text
            style={{
              fontSize: 6,
              color: "#008000",
              bold: true,
              x: x + 1.35,
              y: y + 1.25,
              w: 1.2,
              h: 0.2,
            }}
          >
            {`${-relativeChange(bm.pain, bm.painBenchmark).toFixed(
              1
            )}% below benchmark`}
          </Text>
        )}
      </>
    </>
  );
};
